import { z, ZodErrorMap, ZodIssueCode } from "zod";
import { Address } from "../types/address";
import { validarReferenciaCatastral } from "../AddressField";
import { matchIsValidTel } from "mui-tel-input";
import * as EmailValidator from 'email-validator';

const customErrorMap: ZodErrorMap = (issue, ctx) => {
  if (issue.code === ZodIssueCode.invalid_enum_value) {
    return { message: 'common:text.required_field' };
  }
  if (issue.code === ZodIssueCode.invalid_type) {
    return { message: 'common:text.required_field' };
  }

  // Retorna el missatge per defecte per altres errors
  return { message: ctx.defaultError };
};

export const zodAddressSchema = z.object({
  dp: z.string().min(1, 'common:text.required_field')
    .min(5, 'common:text.contractation_postal_code_length'),
  ine: z.string().min(1, 'common:text.required_field'),
  state: z.number({errorMap: customErrorMap}).min(1, 'common:text.required_field'),
  poblacio: z.string({errorMap: customErrorMap}).min(1, 'common:text.required_field'),
  tv: z.number({errorMap: customErrorMap}).min(1, 'common:text.required_field'),
  nv: z.string().min(1, 'common:text.required_field').max(256, 
    'common:text.address_validation_nv_length'),
  pnp: z.string().min(1, 'common:text.required_field').max(9, 
    'common:text.address_validation_pnp_length'),
  bq: z.string().max(4, 'common:text.address_validation_bq_length').optional(),
  es: z.string().max(4, 'common:text.address_validation_es_length').optional(),
  pt: z.string().max(10, 'common:text.address_validation_pt_length').optional(),
  pu: z.string().max(4, 'common:text.address_validation_pu_length').optional(),
  // TODO: Comprovar quina de les dues ref_catastral és bona
  ref_catastral: z.string()
    .optional()
    .refine(
      val => val ? (val.length === 14 || val.length === 20) : true,
      'common:text.address_validation_ref_catastral_length'
    ),

  // Sembla ser que aquesta validació no funciona
  // ref_catastral: z.string()
  //   .refine(
  //     val => validarReferenciaCatastral(val), 
  //     'common:text.contractation_not_valid_ref'
  //   ).optional(),
  aclarador: z.string().optional(),
  mobile: z.string()
    .min(4, 'common:text.required_field')
    .refine(
      (tel) => matchIsValidTel(tel), 
      {message: 'common:text.lead_contact_phone_not_valid'}
    ).optional(),
  email: z.string()
    .refine(
      (email) => EmailValidator.validate(email)
    ).optional()
}) satisfies z.ZodType<Address>;